// Filter-Panels der Shop-Seiten (Kundenwunsch 13.10.2026: „jetzt bitte alle shop seiten überarbeiten“): statt der
// Filterzeile unter dem Tabellenkopf dasselbe Panel wie Verkäufe, Zahlungen und Stammdaten (saleFilters.js) mit eigenen
// Umschaltern und Listen. Gefiltert wird im Browser über die geladenen Zeilen des Monats.
import moment from 'moment';

function valueOf(value) {
  return value === null || value === undefined || value === '' ? null : value;
}

function isOne(value) {
  return value === true || value === 1 || value === '1';
}

// Texte wie in den Spalten der Seiten
export const STRIPE_STATUS_TEXT = { succeeded: 'Erfolgreich', requires_payment_method: 'Unvollständig' };
export const PAYPAL_STATUS_TEXT = {
  LOADING: 'wird geladen…',
  COMPLETED: 'Erfolgreich',
  REFUNDED: 'Zurückerstattet',
  PARTIALLY_REFUNDED: 'Teilweise zurückerstattet',
  PENDING: 'Ausstehend'
};
export const TICKET_STATUS_TEXT = { OPEN: 'Offen', FINISHED: 'Abgeschlossen', CANCELED: 'Storniert' };
// Vertriebskanal der Shop-Tickets (Kundenwunsch 13.10.2026: „vertriebskanal wie shop provision oder vor ort mit
// fahrscheindrucker … als spalte und icon wie davor“): Text und Icon wie früher die Spalte „Typ“
export const TICKET_TYPE_TEXT = { MOBILE: 'Vor Ort (Fahrscheindrucker)', ONLINE: 'Online-Shop', ONLINE_AGENCY: 'Agentur (Provision)' };
export const TICKET_TYPE_ICON = { MOBILE: 'tablet', ONLINE: 'bag', ONLINE_AGENCY: 'briefcase' };

// Zeitstempel in ms für die Zeitpunkte von–bis (saleFilters.js, Kundenwunsch 14.10.2026): ISO-Text bzw. Unix-Sekunden
// (Stripe); ohne gültigen Wert null
function timeMs(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const m = moment(value);
  return m.isValid() ? m.valueOf() : null;
}

function unixMs(seconds) {
  const n = Number(seconds);
  return seconds !== null && seconds !== undefined && seconds !== '' && isFinite(n) ? n * 1000 : null;
}

// Stripe und PayPal: Zahlungs- und Rückerstattungszeit wie die Spalten (Kundenwunsch 14.10.2026, Edzards: „Bei den
// Rücküberweisungen der Stornos fehlt der Filter auch noch bei Stripe u. Pay Pal“). Gefiltert werden die geladenen
// Zahlungen des Monats (Backend nach Zahlungsmonat, wie früher die Filterzeile).
const REFUND_SEGMENT = {
  key: 'refund',
  label: 'Rückerstattung',
  items: [{ value: null, text: 'Alle' }, { value: 'ohne', text: 'Ohne' }, { value: 'mit', text: 'Mit' }]
};

// Stripe: Rückerstattung, Zahlungsart, Status, Währung; Betrag (brutto, Cent → Euro)
export const STRIPE_FILTER_CONFIG = {
  segments: [Object.assign({}, REFUND_SEGMENT, {
    match: (value, row) => (value === 'mit' ? Number(row.amount_refunded) > 0 : !(Number(row.amount_refunded) > 0))
  })],
  lists: [
    { key: 'methods', field: 'payment_method_details_type', label: 'Zahlungsart' },
    { key: 'status', field: 'status', label: 'Status' },
    { key: 'currencies', label: 'Währung', value: row => (row.currency ? String(row.currency).toUpperCase() : null) }
  ],
  times: [
    { key: 'paid', label: 'Zahlungszeit', value: row => unixMs(row.created) },
    { key: 'refunded', label: 'Rückerstattungszeit', value: row => unixMs(row.refund_date) }
  ],
  amountField: 'amount',
  amountValue: row => (valueOf(row.amount) === null ? null : Number(row.amount) / 100),
  amountLabel: 'Brutto'
};

// PayPal: Rückerstattung, Status, Währung; Betrag
export const PAYPAL_FILTER_CONFIG = {
  segments: [Object.assign({}, REFUND_SEGMENT, {
    match: (value, row) => (value === 'mit' ? Number(row.refunded_amount) > 0 : !(Number(row.refunded_amount) > 0))
  })],
  lists: [
    { key: 'status', field: 'status', label: 'Status' },
    { key: 'currencies', label: 'Währung', value: row => (row.currency ? String(row.currency).toUpperCase() : null) }
  ],
  // Zahlungszeit: bis zur Anreicherung die Bestellzeit aus der Datenbank (created_at)
  times: [
    { key: 'paid', label: 'Zahlungszeit', value: row => timeMs(row.created || row.created_at) },
    { key: 'refunded', label: 'Rückerstattungszeit', value: row => timeMs(row.refund_date) }
  ],
  amountField: 'amount',
  amountLabel: 'Betrag'
};

// Kaufzeit eines Tickets in ms: time, sonst Beginn des Tags aus date
function ticketPurchaseMs(row) {
  const fromTime = row ? timeMs(row.time) : null;
  if (fromTime !== null || !row || !row.date) {
    return fromTime;
  }
  const m = moment(String(row.date), 'DD.MM.YYYY', true);
  return m.isValid() ? m.valueOf() : null;
}

// Tickets: Check-In, Status, Vertriebskanal, Zahlungsanbieter (wie die Spalte aus PayPal-/Stripe-Feldern), Verkäufer, Fahrt,
// Zeitpunkte Gekauft und Letzte Änderung von–bis (Kundenwunsch 14.10.2026, Edzards: „Letzte Änderung 13.10.2026 <
// 05:24 Uhr“); Preis
export const TICKET_FILTER_CONFIG = {
  segments: [{
    key: 'checkin',
    label: 'Check-In',
    items: [{ value: null, text: 'Alle' }, { value: 'ja', text: 'Eingecheckt' }, { value: 'nein', text: 'Offen' }],
    match: (value, row) => (value === 'ja' ? isOne(row.checked_in) : !isOne(row.checked_in))
  }],
  lists: [
    { key: 'status', field: 'status', label: 'Status' },
    { key: 'types', field: 'type', label: 'Vertriebskanal', icon: key => TICKET_TYPE_ICON[key] || null },
    {
      key: 'providers',
      label: 'Zahlungsanbieter',
      value: (row) => {
        if (row.paypal_order_id || row.paypal_capture_id) {
          return 'PAYPAL';
        }
        return row.stripe_payment_intent ? 'STRIPE' : null;
      }
    },
    { key: 'sellers', field: 'fullname', label: 'Verkäufer' },
    { key: 'trips', field: 'trip_id', label: 'Fahrt' }
  ],
  // Kauf und letzte Änderung (Kundenwunsch 14.10.2026: „filter nach bestelltag … gekauft, letzte änderung“; erst als
  // Tageslisten, seit der Rückmeldung von Edzards am selben Tag als Zeitpunkte mit Kalender und Uhrzeit)
  times: [
    { key: 'purchased', label: 'Gekauft', value: ticketPurchaseMs },
    { key: 'modified', label: 'Letzte Änderung', value: row => timeMs(row.modification_time) }
  ],
  amountField: 'price',
  amountLabel: 'Preis'
};

// Fahrtdatum als Schlüssel 'YYYY-MM-DD' in Ortszeit (wie der frühere Datumsfilter der Spalte)
export function tripDayKey(row) {
  if (!row || !row.day) {
    return null;
  }
  const m = moment(row.day);
  return m.isValid() ? m.format('YYYY-MM-DD') : null;
}

// Fahrten: Status, Richtung; Datum (vorbelegt heute, wie bisher die Filterzeile), Linie
export const TRIP_FILTER_CONFIG = {
  segments: [
    {
      key: 'state',
      label: 'Status',
      items: [{ value: null, text: 'Alle' }, { value: 'ACTIVE', text: 'Gültig' }, { value: 'CANCELED', text: 'Storniert' }],
      match: (value, row) => row.state === value
    },
    {
      key: 'direction',
      label: 'Richtung',
      items: [{ value: null, text: 'Alle' }, { value: 'hin', text: 'Hin' }, { value: 'rueck', text: 'Rück' }],
      match: (value, row) => (value === 'hin' ? isOne(row.is_outward_direction) || row.is_outward_direction === true
        : !(isOne(row.is_outward_direction) || row.is_outward_direction === true))
    }
  ],
  lists: [
    { key: 'days', label: 'Datum', value: tripDayKey },
    { key: 'lines', field: 'line_id', label: 'Linie' }
  ],
  amountField: 'price',
  amountLabel: 'Umsatz'
};
